import { render, staticRenderFns } from "./messageRecord.vue?vue&type=template&id=9fd62010&scoped=true&"
import script from "./messageRecord.vue?vue&type=script&lang=js&"
export * from "./messageRecord.vue?vue&type=script&lang=js&"
import style0 from "./messageRecord.vue?vue&type=style&index=0&id=9fd62010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd62010",
  null
  
)

export default component.exports